import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./ProfileResources.da.resx"
import { R as _en } from "./ProfileResources.en.resx"
import { R as _no } from "./ProfileResources.no.resx"

type Translations = {
	"EditMyInformationLabelA11y": string,
	"Name": string,
	"Phone": string,
	"Email": string,
	"Edit": string,
	"Save": string,
	"InvalidCpr": string,
	"InvalidEmail": string,
	"NetworkError": string,
	"ErrorInvitePartner": string,
	"PartnerEmailRequired": string,
	"PartnerNameRequired": string,
	"PartnerCprRequired": string,
	"Active": string,
	"Invited": string,
	"NoPartner": string,
	"AlreadyHasPartner": string,
	"InvitePartner": string,
	"OpenDeleteHouseholdMemberModalA11y": string,
	"OpenEditPetModalA11y": string,
	"OpenDeletePetModalA11y": string,
	"AddPet": string,
	"EditPet": string,
	"PetName": string,
	"PetSex": string,
	"PetRace": string,
	"PetRacePlaceholder": string,
	"PetBirthdate": string,
	"PetBirthdateHint": string,
	"PetType": string,
	"PetWeight": string,
	"PetWeightPlaceholder": string,
	"MonthJanuary": string,
	"MonthFebruary": string,
	"MonthMay": string,
	"MonthMarch": string,
	"MonthApril": string,
	"MonthJune": string,
	"MonthJuly": string,
	"MonthAugust": string,
	"MonthSeptember": string,
	"MonthOctober": string,
	"MonthNovember": string,
	"MonthDecember": string,
	"SelectMonth": string,
	"SelectYear": string,
	"PetSexMale": string,
	"PetSexFemale": string,
	"PetSexMaleNeutered": string,
	"PetSexFemaleSterilized": string,
	"PetSexUnknown": string,
	"PetTypeDog": string,
	"PetTypeCat": string,
	"PetTypeRabbit": string,
	"PetTypeRodent": string,
	"SelectPetType": string,
	"SelectPetSex": string,
	"ConfirmAddPet": string,
	"ConfirmEditPet": string,
	"PleaseEnterPetName": string,
	"PleaseSelectPetType": string,
	"PleaseSelectPetSex": string,
	"PleaseChoosePetAge": string,
	"PleaseSelectMonth": string,
	"PleaseSelectYear": string,
	"RemovePet": string,
	"RemovePetText": string,
	"KeepPet": string,
	"ErrorAddPet": string,
	"ErrorEditPet": string,
	"ErrorDeletePet": string,
	"RemovePartner": string,
	"RemovePartnerText": string,
	"KeepHouseholdMember": string,
	"RemoveHouseholdMember": string,
	"Partner": string,
	"RemoveAccess": string,
	"ErrorDeletePartner": string,
	"Profile_Description_Children": string,
	"Profile_AddChild": string,
	"OpenEditChildModalA11y": string,
	"OpenDeleteChildModalA11y": string,
	"FullName": string,
	"CprNumber": string,
	"ProfileConfirmAddKid": string,
	"ProfileConfirmEditKid": string,
	"Profile_EditChild": string,
	"PleaseEnterFullName": string,
	"CprPlaceholder": string,
	"CprRequired": string,
	"CprTooOld": string,
	"DeleteProfile": string,
	"RemoveChildText": string,
	"KeepProfile": string,
	"ConfirmCprIsCorrectHeader": string,
	"CprModulusCheckWarning": string,
	"Back": string,
	"ConfirmAndSave": string,
	"RefreshDataError": string,
	"RemoveChild": string,
	"PleaseEnterANumber": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "no" || (!process.env.enforcedLocale && getLocale("da") === "no")) {
			return _no[name] ?? name
		}

		return name
	},
}) as Translations

export { R }